import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              label: _ctx.nameLabel,
              class: "required unique",
              "model-value": _ctx.name,
              "error-messages": _ctx.errorMessages.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:name', $event); _ctx.validateName($event)}),
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateName()))
            }, null, 8, ["label", "model-value", "error-messages"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ontos_computed_input, {
              label: _ctx.$tt('alias'),
              class: "required unique ontos-code",
              value: _ctx.alias,
              onInput: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('update:alias', $event); _ctx.validateAlias($event)}),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateAlias())),
              "error-messages": _ctx.errorMessages.alias,
              source: _ctx.name,
              manual: _ctx.manualAlias,
              "onInput:manual": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualAlias = $event)),
              compute: _ctx.$utils.aliasSuggestion,
              computeOnInput: _ctx.$utils.incompleteAliasSuggestion,
              readonly: _ctx.fixedAlias
            }, null, 8, ["label", "value", "error-messages", "source", "manual", "compute", "computeOnInput", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default")
  ]))
}